/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface EnrollmentCreated
 */
export interface EnrollmentCreated {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof EnrollmentCreated
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof EnrollmentCreated
     */
    enrollmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof EnrollmentCreated
     */
    studentId?: ActorActivityRecordActorUserId | null;
}

/**
 * Check if a given object implements the EnrollmentCreated interface.
 */
export function instanceOfEnrollmentCreated(value: object): value is EnrollmentCreated {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('enrollmentId' in value) || value['enrollmentId'] === undefined) return false;
    return true;
}

export function EnrollmentCreatedFromJSON(json: any): EnrollmentCreated {
    return EnrollmentCreatedFromJSONTyped(json, false);
}

export function EnrollmentCreatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrollmentCreated {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['enrollmentId']),
        'studentId': json['studentId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['studentId']),
    };
}

export function EnrollmentCreatedToJSON(json: any): EnrollmentCreated {
    return EnrollmentCreatedToJSONTyped(json, false);
}

export function EnrollmentCreatedToJSONTyped(value?: EnrollmentCreated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['enrollmentId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
    };
}

